import React, { useState } from "react";
import { Box, Grid, Tab, useMediaQuery } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
import PaymentsIcon from "@mui/icons-material/Payments";
import PaymentIcon from "@mui/icons-material/Payment";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { useSearchParams, Navigate } from "react-router-dom";

import { app_title } from "../../config";
import Loading from "../../components/Loading";

import Profile from "./Profile";
import Branding from "./Branding";
import Plan from "./Plan";
import Subscription from "./Subscription";
import OneTimePayment from "./OneTimePayment";

function Settings() {
  // get query(search) params logic start
  const [searchParams] = useSearchParams();

  const subscriptionId = searchParams.get("subscriptionId");
  const oneTimePaymentId = searchParams.get("oneTimePaymentId");
  // get query(search) params logic end

  // user detail
  const user = useSelector((state) => state.user);

  // branding details
  const brandingDtl = useSelector((state) => state.branding);

  // media query for mobile screen
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  // tab value logic start
  const [value, setValue] = useState(
    subscriptionId
      ? "Subscription"
      : oneTimePaymentId
      ? "OneTimePayment"
      : "Profile"
  );

  const handleChange = (e, newValue) => {
    setValue(newValue);
  };
  // tab value logic end

  return (
    <Box
      sx={{
        overflow: "auto",
        paddingX: { xs: 1, sm: 5 },
        paddingY: 3,
        minHeight: "82vh",
      }}
    >
      <Helmet>
        <title>
          Settings - {value} | {brandingDtl.pageTitle || app_title}
        </title>
      </Helmet>
      <Grid container sx={{ minWidth: 300 }}>
        <Box sx={{ width: "100%", typography: "body1" }}>
          {!user.id ? (
            <Loading />
          ) : (
            <TabContext value={value}>
              <TabList
                onChange={handleChange}
                centered={!isMobile}
                variant={isMobile ? "scrollable" : "standard"}
                scrollButtons="auto"
                allowScrollButtonsMobile
              >
                <Tab
                  label="Profile"
                  icon={<ManageAccountsIcon />}
                  iconPosition="start"
                  value="Profile"
                />
                {user.isAdmin && (
                  <Tab
                    label="Branding"
                    icon={<DisplaySettingsIcon />}
                    iconPosition="start"
                    value="Branding"
                  />
                )}
                {user.isDefault && (
                  <Tab
                    label="Plan"
                    icon={<PaymentsIcon />}
                    iconPosition="start"
                    value="Plan"
                  />
                )}
                {user.isAdmin && (
                  <Tab
                    label="Subscription"
                    icon={<AccountBalanceWalletIcon />}
                    iconPosition="start"
                    value="Subscription"
                  />
                )}
                {user.isAdmin && (
                  <Tab
                    label="One-Time Payment"
                    icon={<PaymentIcon />}
                    iconPosition="start"
                    value="OneTimePayment"
                  />
                )}
              </TabList>
              <TabPanel value="Profile">
                <Profile />
              </TabPanel>
              <TabPanel value="Branding">
                {user.isAdmin ? <Branding /> : <Navigate to="/dashboard" />}
              </TabPanel>
              <TabPanel value="Plan">
                {user.isDefault ? <Plan /> : <Navigate to="/dashboard" />}
              </TabPanel>
              <TabPanel value="Subscription">
                {user.isAdmin ? <Subscription /> : <Navigate to="/dashboard" />}
              </TabPanel>
              <TabPanel value="OneTimePayment">
                {user.isAdmin ? (
                  <OneTimePayment />
                ) : (
                  <Navigate to="/dashboard" />
                )}
              </TabPanel>
            </TabContext>
          )}
        </Box>
      </Grid>
    </Box>
  );
}

export default Settings;
